import { useReducer } from 'react';
import {
    type ExtendedPageState,
    type ExtendedPageAction,
    extendedReducer,
} from '../../../components/PaginatedTableWithContext';

type State = ExtendedPageState;

type Action = ExtendedPageAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        default:
            return extendedReducer(state, action);
    }
};

const useListReducer = (cache?: State) =>
    useReducer(reducer, {
        companyId: cache?.companyId,
        // default pagination
        page: cache?.page || 1,
        pageSize: cache?.pageSize || 10,
    });

export default useListReducer;
